import React, { useState, useCallback, useEffect } from "react";
import Grid from '@material-ui/core/Grid';
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";

import { Wrapper, WrapperPartners, Partners } from "./styles";
import { Container } from "../../../components/design/layout/container";
import { Headline } from "../../../components/design/foundation/headline";
import ProductBox from "../../../components/design/layout/product-box";
import { NothingMessage } from '../../../components/ui/nothing-message';

import OfferService from "../../../services/Offer";

import loadImage from "../../../utils/LoadImage";
import ProductLoader from "../../../components/design/layout/loader/product";

function MyActiveOffers({ website }) {
    const [activeOffers, setActiveOffers] = useState([]);

    const [isLoading, setIsLoading] = useState({
        status: false,
        haveActiveOffers: false
    });

    const handleListActiveOffers = useCallback(() => {
        const offerService = new OfferService();
        setIsLoading(prev => prev = { ...prev, status: true, haveActiveOffers: true });


        offerService.listActiveFromUser().then((response) => {
            setActiveOffers(response.data.payload);

            if (response.data.payload) {
                setIsLoading(prev => prev = { ...prev, status: false, haveActiveOffers: true });
            } else {
                setIsLoading(prev => prev = { ...prev, status: false, haveActiveOffers: false });
            }
        });
    }, []);

    useEffect(() => {
        handleListActiveOffers();
    }, [handleListActiveOffers]);

    return (
        <Wrapper>
            <Container withContainer={true} className="ContainerBottom">
                {/* <ActivePromotions link="#!!" /> */}
                <WrapperPartners>
                    <Partners>
                        <Headline
                            type="medium"
                            title="Minhas ofertas ativas"
                            subTitle="Confira abaixo todas as suas ofertas ativas"
                            textAlign="left"
                        />

                        {isLoading.status && (<Grid container spacing={0}>
                            {[0, 1, 2, 3].map(() =>
                                <Grid item xs={6}>
                                    <ProductLoader />
                                </Grid>
                            )}
                        </Grid>)}

                        {!isLoading.haveActiveOffers && (
                            <NothingMessage>
                                Você ainda não ativou nenhuma oferta
                            </NothingMessage>
                        )}

                        <Grid container spacing={0}>
                            {activeOffers && activeOffers.map((item) => (
                                <Grid item xs={6}>
                                    <ProductBox
                                        gridMargin={5}
                                        productId={item._id}
                                        discountValue={item.descont ? item.descont : null}
                                        productTitle={item.titulo}
                                        image={loadImage({ imageCode: item.imagens[0] })}
                                        productPrice={item.oferta}
                                        productType={item.tipo_oferta}
                                        priceColor={props => props.theme[website]?.components.productBox.priceColor}
                                        announcedBy={item.empresa ? website : 'parceiro'}
                                        company={website}
                                    />
                                </Grid>
                            ))}
                        </Grid>

                        {/* <WrappLoadMore>
                            <Button
                                styleType="bordered"
                                buttonSize="small"
                                buttonColor="#FFFFFF"
                                textColor="#1852CC"
                                buttonText="Mostrar mais parceiros"
                                borderColor="#1852CC"
                                maxWidth={200}
                                onClick={() => alert("Load more")}
                            />
                        </WrappLoadMore> */}
                    </Partners>
                </WrapperPartners>
            </Container>
        </Wrapper>
    )
}


const mapStateToProps = (state) => {
    return {
        scamber: state.scamberReducer.scamber,
        website: state.websiteReducer.website
    };
};

export default withRouter(connect(mapStateToProps)(MyActiveOffers));
